//funzione ch ritorna il button del calcolo percorso
import React from 'react'
import {Component} from 'react'
import TripIcon from '../DrawerButton/Calcolodelpercorso.svg'
import Tooltip from '@material-ui/core/Tooltip';
import { connect } from 'react-redux'
import {fetchPath,selectNewIndex, selectNewMarkerStart2, selectNewMarkerEnd2,changeNomeFermataStart,changeNomeFermataEnd, changePercorsoDrawer,changePercorsoTariffa} from '../../redux'
 class ButtonMenu extends Component {
constructor(props){
    super(props);
    this.state = {
        buttonStyle: props.button,
        buttonImage: {
            position: 'absolute',
            left:0,
            top: 9,
            color: 'gray'
            
        },
        isToggleOn: true
      }
          // This binding is necessary to make `this` work in the callback
        
          
          this.handleClick = this.handleClick.bind(this);

}
//funzione per aprire il menù dal button
handleClick() {

    
    this.setState(function(prevState) {
        this.props.openMenu(true)
        return {isToggleOn: !prevState.isToggleOn};
    });
    //this.props.changePercorsoDrawer(this.state.isToggleOn)
    this.props.percorsoTariffa.percorsoTariffa = false
    this.props.percorsoDrawer.percorsoDrawer = true
    
}

render() {  
    return (
        // <Slide direction="left" in={this.state.isToggleOn } >
        <Tooltip title="Calcola il percorso">
        <button  style={ this.state.buttonStyle} onClick={this.handleClick} id={"CalcolaPercorso"}>
            <img src={TripIcon} alt="trip"/>
        </button>
        </Tooltip>
        )
    }
}

const mapStateToProps = state => {
    return {
       
        markerStart2: state.markerStart2,
        markerEnd2: state.markerEnd2,
        nomeFermataStart:state.nomeFermataStart,
        nomeFermataEnd: state.nomeFermataEnd,
        percorsoDrawer : state.percorsoDrawer,
        percorsoTariffa : state.percorsoTariffa
  
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
       
        markerStart2: (marker) => dispatch(selectNewMarkerStart2(marker)),
        markerEnd2: (marker) => dispatch(selectNewMarkerEnd2(marker)),
        changeNomeFermataStart :(nomeFermataStart) => dispatch(changeNomeFermataStart(nomeFermataStart)),
        changeNomeFermataEnd :(nomeFermataEnd) => dispatch(changeNomeFermataEnd(nomeFermataEnd)),
        changePercorsoDrawer: (percorsoDrawer) => dispatch(changePercorsoDrawer(percorsoDrawer)),
        changePercorsoTariffa: (percorsoTariffa) => dispatch(changePercorsoTariffa(percorsoTariffa))
  
    }
  }
  
  
  
  
  export default connect(mapStateToProps,mapDispatchToProps) (ButtonMenu)